import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../Modal/Modal'

export interface AutoJoinConfirmModalProps {
  show: boolean
  onHide: () => void
  changeTo: boolean | null
  thisMeetingLoading?: boolean
  allMeetingsLoading?: boolean
  onThisMeeting: (autoJoin: boolean | null) => void
  onAllMeetings: (autoJoin: boolean | null) => void
}

export const AutoJoinConfirmModal: React.FC<AutoJoinConfirmModalProps> = ({
  show,
  onHide,
  changeTo,
  thisMeetingLoading = false,
  allMeetingsLoading = false,
  onThisMeeting,
  onAllMeetings,
}) => {
  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Adjust auto join for meeting</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <div className='paragraph-medium'>
            This meeting is part of a series of recurring meetings. Do you want to adjust only this meeting or all meetings in the series?
          </div>
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={() => onThisMeeting(changeTo)}
      onFooterSecondaryAction={() => onAllMeetings(changeTo)}
      footerPrimaryActionTitle='This meeting'
      footerSecondaryActionTitle='All meetings'
      footerPrimaryActionLoading={thisMeetingLoading}
      footerSecondaryActionLoading={allMeetingsLoading}
    />
  )
}
